import React, {useState, useEffect} from 'react';
import SurveysService from '../../../../../services/SurveysService';
import TemplateQuestionBox from './TemplateQuestionBox';
import {withToastManager} from "react-toast-notifications";
import { Link, useLocation } from 'react-router-dom';
import LoadingIndicator from "../../../../meta/LoadingIndicator";
import DOMPurify from 'dompurify';


function TemplatePreview(props) {
    const surveyId = props.match.params.surveyId;
    const location = useLocation();
    const [survey, setSurvey] = useState({});
    const [surveyLoading, setSurveyLoading] = useState(true);
    const [surveyLoadingError, setSurveyLoadingError] = useState(false);

    useEffect(() => {
        if(typeof survey !== "undefined") {
            setSurveyLoading(true);
            setSurveyLoadingError(false);
        }
        if(surveyId) {
            SurveysService.getSurveyTemplateById(surveyId,
                (success) => {
                    setSurvey(success.data);
                    setSurveyLoading(false)
                }, () => {
                    props.toastManager.add("Error! Cannot retrieve template", {
                        appearance: 'error'
                    });
                    setSurveyLoadingError(true);
                }
            );
        }
    }, [location.pathname]);

    const renderQuestionsList = (questions) => {
        let htmlQuestionsList;
        htmlQuestionsList = questions.map((question, idx) => {
            return (
                <TemplateQuestionBox questionData={question} key={"template_question_item_" + idx} />
            )});
        return (
            <React.Fragment>
                {htmlQuestionsList}
            </React.Fragment>
        );
    };

    const useThisTemplateButton = (e) => {
        e.preventDefault();
        if(props.isTemplateGettingCloned) return;
        props.useTemplate(surveyId);
    };

    const startFromScratchButton = (e) => {
        e.preventDefault();
        if(props.isTemplateGettingCloned) return;
        props.startFromScratch();
    };

    const previewButtons =
        <div className="template__questions__action">
            <a href="#"
               className={"cta--normal cta--green cta--notransform " + (props.isTemplateGettingCloned ? " cta--disabled " : "")}
               onClick={useThisTemplateButton}
            >Use this template</a>
            <span>OR</span>
            <a href="#"
               className={"cta--normal cta--notransform " + (props.isTemplateGettingCloned ? " cta--disabled " : "")}
               onClick={startFromScratchButton}
            >Start from scratch</a>
        </div>;

    return (
        <div className="template__questions">
            <Link to="/survey-templates" className="mobile__back">Back</Link>
            {surveyLoading ?
                (
                    <React.Fragment>
                        <div className="template__questions__text">
                            <h2>{surveyLoadingError ? "Template Error" : "Loading survey template"}</h2>
                        </div>
                        <div className="template__questions__items">
                            {surveyLoadingError ?
                                ("Error loading survey template!")
                                :
                                (<LoadingIndicator/>)
                            }
                        </div>
                    </React.Fragment>
                )
                :
                (
                    <React.Fragment>
                        <div className="template__questions__text">
                            <h2>{survey.title}</h2>
                            {survey.description && <div dangerouslySetInnerHTML={{__html:DOMPurify.sanitize(survey.description)}} ></div>}
                        </div>
                        {previewButtons}
                        {props.isTemplateGettingCloned && (<div style={{padding: "25px 0px 0px 0px"}}><LoadingIndicator/></div>)}
                        <div className="template__questions__items">
                            {survey.questions && renderQuestionsList(survey.questions)}
                        </div>
                        {previewButtons}
                    </React.Fragment>
                )
            }
        </div>
    )
}

export default withToastManager(TemplatePreview);
